export const SurfaceType = {
    WALL: 'Wall',
    FLOOR: 'Floor',
    CEILING: 'Ceiling'
}

export const ProductPlacementType = {
    Product: 'product',
    Texture: 'texture',
    Color: 'color',
}

export const RoomViewType = {
    top: 'top',
    firstPersonView: 'firstPersonView',
    default: 'default'
}

export const DimensionalViewType = {
    TWO_D: '2D',
    THREE_D: '3D',
}

export const BUILDER_IN_PROGRESS = "inprogress";
export const BUILDER_SUCCESS = "success";
export const BUILDER_FAILED = "failed";
export const BUILDER_NOTIFICATION_INFO = "info";
export const BUILDER_NOTIFICATION_ERROR = "error";
export const BUILDER_NOTIFICATION_SUCCESS = "success";
export const TRIGGER_ROOM_LAYOUT_THUMBNAILS_SAVE = "triggerRoomLayoutThumbnailsSave";

export const METER_TO_INCHES_FACTOR = 39.3701;

export const productDimensionsMap: {
    [key: string]: {
        width: number;
        height: number;
        depth: number;
    }
} = {
    'MNS89653-B': {
        depth: 21.625,
        height: 19,
        width: 21.625
    },
    'MO78654-W': {
        depth: 0,
        height: 0,
        width: 0
    },
    'MRT87653-L': {
        depth: 15.375,
        height: 19.25,
        width: 15.375
    },
    'BMR56898-K': {
        depth: 74.75,
        height: 42.5,
        width: 87.75
    },
    'OT924-1': {
        depth: 26,
        height: 24,
        width: 24
    },
    'FS5705-1': {
        depth: 100,
        height: 32,
        width: 40
    },
    'FS5703-1': {
        depth: 90,
        height: 38.5,
        width: 38
    },
    'OT920-1': {
        depth: 48,
        height: 15,
        width: 35
    },
    'OT923-1': {
        depth: 12,
        height: 21,
        width: 12
    },
    'FS571-O': {
        depth: 38,
        height: 18,
        width: 38
    },
    'FS568-1': {
        depth: 32.5,
        height: 38,
        width: 35
    },
    'FS577-o': {
        depth: 19,
        height: 18,
        width: 19
    }
}
